module.exports = __webpack_public_path__ + "img/gw.57eb55f4.svg";